export function createResultsWorkspaceStore(initialState = null) {
  const stateRef = {
    current: initialState,
  };

  return {
    getState() {
      return stateRef.current;
    },
    setState(nextState) {
      stateRef.current = nextState;
      return stateRef.current;
    },
    stateRef,
    withState(callback) {
      if (typeof callback !== "function" || !stateRef.current) {
        return null;
      }

      return callback(stateRef.current);
    },
  };
}